export default "__VITE_ASSET__C5c7_gxq__ 600w";